var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"test",attrs:{"search":"","data":_vm.data,"placeholder":_vm.placeholder,"filter":_vm.filter},on:{"search":_vm.search,"change":_vm.select,"blur":_vm.blur,"focus":_vm.focus},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_vm._t("default",[_vm._v(_vm._s(data.label))],{data:data})]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52151814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/auto-complete/auto-complete.vue
// module id = null
// module chunks = 